import RadioButtonGroup from './RadioButtonGroup';
import { deprecate } from '../../../../common/DeprecationService';

deprecate(
  'forms/RadioButtonGroup',
  'Radio from @patternfly/react-core',
  '3.21'
);

export default RadioButtonGroup;
